<template>
    <div class="component-wrap">
        <div v-for="(item, index) in list" :key="index" class="table_item" @click="onClick(item)">
            <div class="item_header fx-row fx-center">
                <div class="name fx-fill txt-ellipsis" >{{ item.name }}</div>
                <div v-if="item.minPrice" class="price fc-tips">
                    <span class="fc-active">￥{{item.minPrice}}</span> 起
                </div>
            </div>
            <div class="item_footer fx-row fx-between fx-center">
                <div class="address fx-fill txt-ellipsis">{{item.address}}</div>
                <div class="distance fc-tips">{{item.distance | formatDistance}}</div>
            </div>
            <div class="item_tag" v-if="item.tagList && item.tagList.length > 0">
                <van-tag v-for="item, index in item.tagList" :key="index"  color="#fcc757" style="margin-right: 5px;" plain>{{ item}}</van-tag>
            </div>
            <div v-if="item.recentlyOpi" style="padding-top: 5px;">
                <div class="fc-tips">最近场次
                    <span>{{item.recentlyOpi}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: Array,
    },
    data() {
        return {}
    },
    methods: {
        onClick(item) {
            this.$emit('click', item.id);
        }
    }
}
</script>

<style lang="scss" scoped>
.component-wrap {
	padding: 0 15px;
	.table_item {
		background-color: #fff;
		width: 100%;
		border-radius: 2px;
		padding: 10px 12px;
		margin: 10px 0;
		position: relative;
		.item_header {
			padding-bottom: 8px;
			width: 100%;
		}
		.item_footer {
			padding-top: 5px;
		}

        .item_tag {
            padding-top: 10px;
        }
		.name {
			font-size: 15px;
			color: #3f4956;
			// font-family: "pf medium";
		}
		.address {
			color: $tips-color;
		}

		.h {
			position: absolute;
			right: -5px;
			top: -5px;
		}
	}
}
</style>
